import React, { useState } from "react";
import { Calendar } from "react-date-range";
import { format } from "date-fns";

import { CalendarMonthOutlined } from "@mui/icons-material";
import { Grid, InputAdornment, TextField } from "@mui/material";
import AnalyticsService from "../../Services/AnalyticsService";

export default function StatementCustomDate({
  classes,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  setSelectedPeriodValue,
}) {
  const [showStartDatePicker, setShowStartDatePicker] = useState(false);
  const [showEndDatePicker, setShowEndDatePicker] = useState(false);
  const inputProps = {
    readOnly: true,
    style: {
      height: 40,
      fontSize: "13px",
      backgroundColor: "#EEE",
      borderRadius: "8px",
    },
    endAdornment: (
      <InputAdornment position="end">
        <CalendarMonthOutlined />
      </InputAdornment>
    ),
  };

  const getDateText = (date) => {
    return date ? date.split("/").reverse().join("/") : "";
  };

  const getCalenderDate = (date) => {
    return date ? new Date(date) : new Date();
  };

  const handleStartDateChange = (item) => {
    const selectedDate = format(new Date(item).getTime(), "yyyy/MM/dd");
    AnalyticsService.pushEvent("Hisaab PDF Start Date Changed", {
      previousDate: startDate,
      selectedDate: selectedDate,
    });

    setStartDate(selectedDate);
    setShowStartDatePicker(!showStartDatePicker);
    setSelectedPeriodValue(null);
  };

  const handleEndDateChange = (item) => {
    const selectedDate = format(new Date(item).getTime(), "yyyy/MM/dd");
    AnalyticsService.pushEvent("Hisaab PDF End Date Changed", {
      previousDate: endDate,
      selectedDate: selectedDate,
    });

    setEndDate(selectedDate);
    setShowEndDatePicker(!showEndDatePicker);
    setSelectedPeriodValue(null);
  };

  return (
    <Grid item xs={12} container className={classes.formGroup}>
      <Grid item xs={5.8} sx={{ position: "relative" }}>
        <TextField
          type="text"
          fullWidth
          placeholder="Start Date"
          value={getDateText(startDate)}
          onClick={() => {
            setShowStartDatePicker(!showStartDatePicker);
            setShowEndDatePicker(false);
          }}
          sx={{ "& fieldset": { border: "none" } }}
          InputProps={inputProps}
        />

        {showStartDatePicker && (
          <div className={classes.startDateCalenderWrapper}>
            <Calendar
              date={getCalenderDate(startDate)}
              onChange={handleStartDateChange}
            />
          </div>
        )}
      </Grid>

      <Grid item xs={5.8} sx={{ position: "relative" }}>
        <TextField
          type="text"
          fullWidth
          placeholder="End Date"
          value={getDateText(endDate)}
          onClick={() => {
            setShowStartDatePicker(false);
            setShowEndDatePicker(!showEndDatePicker);
          }}
          sx={{ "& fieldset": { border: "none" } }}
          InputProps={inputProps}
        />

        {showEndDatePicker && (
          <div className={classes.endDateCalenderWrapper}>
            <Calendar
              date={getCalenderDate(endDate)}
              onChange={handleEndDateChange}
              minDate={getCalenderDate(startDate)}
            />
          </div>
        )}
      </Grid>
    </Grid>
  );
}
